import { useState, useEffect } from 'react';
import API from "../providers/api";


export default () => {
  const [etiquetas, setEtiquetas] = useState(null);
  const [isBusy, setIsBusy] = useState(true);

  useEffect(() => {
    const fetchEtiquetas = async () => {
      let res
      try {
        res = await API.get("etiquetas");
      } catch (err) {
        setIsBusy(false);
        setEtiquetas([])
        return
      }

      if (res?.status !== 200) {
        setIsBusy(false);
        setEtiquetas([])
      }

      setEtiquetas(res.data || [])
      setIsBusy(false);
    };

    fetchEtiquetas()
  }, []);

  return {etiquetas, isBusy};
}